import { AsyncValidatorFn, FormGroup } from '@angular/forms';
import { DVFormGroup } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { DVBaseAsyncValidator } from 'src/app/shared/helpers/dynamic-validators/base-async-dv';
import * as moment from 'moment';
export function passwordMatch(passwordFieldName = 'password', repeatPasswordFieldName = 'password_repeat') {
  return async (group: FormGroup) => {
    const pass = group.controls[passwordFieldName].value;
    const confirmPass = group.controls[repeatPasswordFieldName].value;
    return pass === confirmPass ? null : { notSame: true };
  };
}
export function startEndDateMatch(startDate = 'startDate', endDate = 'endDate') {
  return async (group: FormGroup) => {
    const sDate = new Date(group.controls[startDate].value);
    const eDate = new Date(group.controls[endDate].value);
    return sDate <= eDate ? null : { notSame: true };
  };
}

export class DateCheckValidator extends DVBaseAsyncValidator {
  constructor(
    protected _fields: [string, string],
    protected _message: string
  ) {
    super('dateCheck');
  }

  protected _validatorFn = () => {
    const start = this._formgroup.controls[this._fields[0]].value;
    const end = this._formgroup.controls[this._fields[1]].value;
    if (!start || !end) {
      return null;
    }
    return moment(start).isBefore(end) ? null : { [this._validatorKey]: true };
  }
}
